import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegCheckCircle } from 'react-icons/fa';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { IoWarningOutline } from 'react-icons/io5';
import { MdCancel } from 'react-icons/md';

interface ComparisonStatsProps {
  totalComponents: number;
  missingInAll: number;
  missingInSome: number;
  complete: number;
}

export const ComparisonStats: FC<ComparisonStatsProps> = ({
  totalComponents,
  missingInAll,
  missingInSome,
  complete,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {/* Total Components */}
      <div className="rounded-lg p-6 bg-day-light-3">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">{t('comparison-stats.total-components')}</p>
            <p className="text-3xl font-bold text-gray-900">{totalComponents}</p>
          </div>
          <HiOutlineDocumentText className="text-gray-400" size={32} />
        </div>
      </div>

      {/* Complete */}
      <div className="rounded-lg p-6 bg-day-light-3">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">{t('comparison-stats.complete')}</p>
            <p className="text-3xl font-bold text-gray-900">{complete}</p>
          </div>
          <FaRegCheckCircle className="text-green-500" size={32} />
        </div>
      </div>

      {/* Missing in Some */}
      <div className="rounded-lg p-6 bg-day-light-3">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">{t('comparison-stats.missing-in-some')}</p>
            <p className="text-3xl font-bold text-gray-900">{missingInSome}</p>
          </div>
          <IoWarningOutline className="text-orange-500" size={32} />
        </div>
      </div>

      {/* Missing in All Documents */}
      <div className="rounded-lg p-6 bg-day-light-3">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">{t('comparison-stats.missing-in-both')}</p>
            <p className="text-3xl font-bold text-gray-900">{missingInAll}</p>
          </div>
          <MdCancel className="text-red-500" size={32} />
        </div>
      </div>
    </div>
  );
};
